/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const knownCustomerNumberPageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const knownCustomerNumberPageResponseOutputItemsItemCustomerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const knownCustomerNumberPageResponseOutputItemsItemNumberRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);
export const knownCustomerNumberPageResponseOutputItemsItemDisplayMax = 80;

export const knownCustomerNumberPageResponseOutputItemsItemCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const knownCustomerNumberPageResponseOutputItemsItemUpdatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const knownCustomerNumberPageResponseOutputNextCursorOneMax = 512;

export const knownCustomerNumberPageResponseOutputNextCursorOneRegExp = new RegExp(
  '^[A-Za-z0-9_-]+$',
);

export const KnownCustomerNumberPageResponseOutput = zod.object({
  items: zod.array(
    zod.object({
      id: zod.uuid().regex(knownCustomerNumberPageResponseOutputItemsItemIdRegExp),
      customerId: zod.uuid().regex(knownCustomerNumberPageResponseOutputItemsItemCustomerIdRegExp),
      number: zod.string().regex(knownCustomerNumberPageResponseOutputItemsItemNumberRegExp),
      display: zod.string().min(1).max(knownCustomerNumberPageResponseOutputItemsItemDisplayMax),
      createdAt: zod.iso
        .datetime({ offset: true })
        .regex(knownCustomerNumberPageResponseOutputItemsItemCreatedAtRegExp),
      updatedAt: zod.iso
        .datetime({ offset: true })
        .regex(knownCustomerNumberPageResponseOutputItemsItemUpdatedAtRegExp),
    }),
  ),
  nextCursor: zod.union([
    zod
      .string()
      .min(1)
      .max(knownCustomerNumberPageResponseOutputNextCursorOneMax)
      .regex(knownCustomerNumberPageResponseOutputNextCursorOneRegExp),
    zod.null(),
  ]),
});

export type KnownCustomerNumberPageResponseOutput = zod.input<
  typeof KnownCustomerNumberPageResponseOutput
>;
export type KnownCustomerNumberPageResponseOutputOutput = zod.output<
  typeof KnownCustomerNumberPageResponseOutput
>;
